import { getItem, getSect, type Appearance, type NpcVisual } from '@jianghu/game-data';
import type { HumanoidLook } from './humanoid';

/** Builds the render description of a player character from sect, appearance and equipment. */
export function playerLook(
  sectId: string,
  appearance: Appearance,
  weaponDefId: string | null,
  armorDefId: string | null,
): HumanoidLook {
  const sect = getSect(sectId);
  const weapon = weaponDefId ? getItem(weaponDefId) : undefined;
  const armor = armorDefId ? getItem(armorDefId) : undefined;
  // Starter robes are part of the outfit itself; stronger armour shows as a tinted vest.
  const showArmor = armor && armor.id !== 'hempen_robe' ? (armor.tint ?? null) : null;
  return {
    appearance,
    trimColor: sect?.colors.trim ?? '#2c3e57',
    accentColor: sect?.colors.accent ?? '#d4a54a',
    armorTint: showArmor,
    weaponModel: weapon?.model ?? null,
    ...(weapon?.tint ? { weaponTint: weapon.tint } : {}),
  };
}

export function npcLook(v: NpcVisual): HumanoidLook {
  return {
    appearance: v,
    trimColor: '#e8dcc0',
    accentColor: '#9b2c2c',
    ...(v.beard ? { beard: v.beard } : {}),
    ...(v.hat ? { hat: v.hat } : {}),
    ...(v.prop ? { prop: v.prop } : {}),
  };
}

export function banditLook(seed: number): HumanoidLook {
  const tones = ['#d6a77e', '#b9825a', '#e8c4a0'];
  return {
    appearance: {
      gender: 'male',
      hairstyle: seed % 2 === 0 ? 'short_crop' : 'long_tail',
      hairColor: '#1b1714',
      face: 'fierce',
      skinTone: tones[seed % tones.length] as string,
      outfitStyle: 'wanderer_coat',
      outfitColor: seed % 3 === 0 ? '#5b4a3a' : '#6b4f3a',
    },
    trimColor: '#3a2a1c',
    accentColor: '#8e2f2a',
    weaponModel: 'saber',
    style: 'bandit',
  };
}
